"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Message = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2020 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
/**
 * @internal
 */
exports.Message = function (_a) {
    var onClose = _a.onClose, type = _a.type, children = _a.children, className = _a.className, contrast = _a.contrast, intensive = _a.intensive;
    var classes = classnames_1.default("gd-message", "s-message", className, {
        success: type === "success",
        progress: type === "progress",
        error: type === "error",
        warning: type === "warning",
        contrast: contrast,
        intensive: intensive,
    });
    return (react_1.default.createElement("div", { className: classes },
        react_1.default.createElement("div", { className: "gd-message-text" },
            children,
            onClose && (react_1.default.createElement("div", { className: "gd-message-dismiss-container" },
                react_1.default.createElement("a", { className: "gd-message-dismiss gd-icon-cross", onClick: onClose }))))));
};
//# sourceMappingURL=Message.js.map